/**
 * Schedule entries and segments are date-only concepts ("this runs June 12 → June 30").
 * The backend stores and compares them as UTC timestamps, so each date is pinned to the
 * UTC day boundaries — start = 00:00:00.000Z, end = 23:59:59.999Z — which lets a UTC range
 * comparison on the backend cover the entire intended day(s).
 *
 * The gantt UI works in local-midnight Dates. On the way out we read the calendar date from
 * the value's *local* components; on the way in we rebuild a local-midnight Date from the
 * *UTC* components. This keeps the displayed day stable in any timezone and round-trips cleanly.
 */
export function toUtcStartOfDay(d: Date | string): Date {
  const x = d instanceof Date ? d : new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), 0, 0, 0, 0));
}

export function toUtcEndOfDay(d: Date | string): Date {
  const x = d instanceof Date ? d : new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), 23, 59, 59, 999));
}

export function utcDateToLocalMidnight(d: Date | string): Date {
  const x = d instanceof Date ? d : new Date(d);
  return new Date(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate());
}
